
import { createElement } from "react";
import React from "react";
import { reactApi, reactElement as reactElement_1 } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { iterate, empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { countRowsMatchingColumnFilters, createColumnDefinition, TextTableCell, ButtonTableCell, ImageTableCell, LabelTableCell, ComponentTableCell, LinkTableCell, DateTimeTableCell, DateTableCell, CheckboxTableCell, TableHeader, CheckboxTableHeader } from "./Table.js";
import { toArray as toArray_1, map as map_2, isEmpty, empty as empty_1, singleton as singleton_1, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { tryFindIndex, item as item_1, mapIndexed, tryItem, map, collect } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { FSharpMap__TryFind, FSharpMap__get_Item, tryFind } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { bind, toArray, ofNullable, map as map_1, defaultArg, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { setQueryParams, takeRememberedRowPath, getColumnVisibilityObject, update as update_1, init as init_1, rememberClickedRow, rowPath } from "./State.js";
import { InventoryTypeBadge } from "../../Components/InventoryTypeBadge.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { TableMsg$1 } from "./Types.js";
import { useTranslation } from "react-i18next";
import { getSortedRowModel as getSortedRowModel_1, getFilteredRowModel as getFilteredRowModel_1, getCoreRowModel as getCoreRowModel_1, useReactTable } from "@tanstack/react-table";
import { useVirtualizer } from "@tanstack/react-virtual";
import { IconButton, TextButton, SmallDropdownButton } from "../../Components/Button.js";
import { ActiveFilterBar, TableSettings, hasActiveFilters, TableElementsCounter } from "./TableControlHeader.js";
import { max } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Double.js";
import { IconInput } from "../../Components/Input.js";
import Magnifying_Glass from "../../../public/assets/icons/Magnifying_Glass.svg";
import { ColumnSelect } from "./ColumnSelect.js";
import { TableFilterDropDown } from "./CustomFilters.js";
import Compress from "../../../public/assets/icons/Compress.svg";
import Expand from "../../../public/assets/icons/Expand.svg";
import Arrow_Up_3 from "../../../public/assets/icons/Arrow_Up_3.svg";

export function InfiniteTableHead(props) {
    let elems;
    return reactElement_1("div", createObj(ofArray([["id", "table-head"], ["className", join(" ", ["row-start-1", "flex", "flex-row", "sticky", "top-0", "z-[1]"])], (elems = toList(delay(() => {
        let matchValue;
        return append((matchValue = props.Options.RowSelection, (matchValue === "singleRow") ? singleton(createElement(CheckboxTableHeader, {
            BorderStyle: props.Options.BorderStyle,
            Checked: props.Table.getIsAllRowsSelected(),
            IsCheckboxVisible: props.Options.RowSelection === "multiRow",
            OnCheck: (arg) => {
                props.Table.toggleAllRowsSelected(arg);
            },
            StickyHeader: props.Options.StickyHeader,
            Table: props.Table,
        })) : ((matchValue === "multiRow") ? singleton(createElement(CheckboxTableHeader, {
            BorderStyle: props.Options.BorderStyle,
            Checked: props.Table.getIsAllRowsSelected(),
            IsCheckboxVisible: props.Options.RowSelection === "multiRow",
            OnCheck: (arg) => {
                props.Table.toggleAllRowsSelected(arg);
            },
            StickyHeader: props.Options.StickyHeader,
            Table: props.Table,
        })) : (empty()))), delay(() => ofArray(collect((x) => x, map((headerGroup) => map((header) => {
            let Key, Text$, ColumnFilter, matchValue_1, FilterValue, OnFilter, objectArg_1;
            return createElement(TableHeader, (($value) => { $value.key = $value.Key; return $value; })((Key = header.id, (Text$ = header.column.columnDef.header, (ColumnFilter = ((matchValue_1 = tryFind(header.id, props.ColumnDefinitionsMap), (matchValue_1 == null) ? "none" : matchValue_1.Filter)), (FilterValue = header.column.getFilterValue(), (OnFilter = ((objectArg_1 = header.column, (arg_1) => {
                objectArg_1.setFilterValue(arg_1);
            })), {
                BorderStyle: props.Options.BorderStyle,
                ColumnDefinitionMap: props.ColumnDefinitionsMap,
                ColumnFilter: ColumnFilter,
                ColumnId: header.id,
                FilterValue: FilterValue,
                Header: header,
                IsDraggable: props.IsDraggable,
                Key: Key,
                OnFilter: OnFilter,
                SetHeaderSize: true,
                SetQueryParams: props.Options.WithQueryParameters,
                StickyHeader: props.Options.StickyHeader,
                Table: props.Table,
                Text: Text$,
            })))))));
        }, headerGroup.headers), props.Table.getHeaderGroups())))));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function InfiniteBaseTable(props) {
    let elems_2, elems_1;
    const table = props.Table;
    const dependencies = [props.GlobalSearch];
    reactApi.useEffect(() => {
        const matchValue = props.GlobalSearch;
        if (matchValue == null) {
        }
        else {
            const globalSearch = matchValue;
            table.setGlobalFilter(globalSearch);
        }
    }, dependencies);
    const items = props.Virtualizer.getVirtualItems();
    return reactElement_1("div", createObj(ofArray([["className", join(" ", ["bg-white", "rounded-md", "w-full", "relative", "grid", "grid-rows-[auto,1fr]"])], ["style", {
        height: props.Virtualizer.getTotalSize(),
    }], (elems_2 = [createElement(InfiniteTableHead, {
        ColumnDefinitionsMap: props.ColumnDefinitionsMap,
        IsDraggable: props.IsHeaderDraggable,
        Options: {
            BorderStyle: props.Options.BorderStyle,
            ConfigurableColumns: props.Options.ConfigurableColumns,
            OnRowClick: unwrap(props.Options.OnRowClick),
            RowSelection: props.Options.RowSelection,
            StickyHeader: props.Options.StickyHeader,
            WithQueryParameters: props.Options.WithQueryParameters,
        },
        Table: table,
    }), reactElement_1("div", createObj(ofArray([["id", "table-body"], ["className", join(" ", ["absolute", "left-0", "w-full", "z-0", "row-start-2"])], ["style", {
        transform: ("translateY(" + defaultArg(map_1((item) => (item.start | 0), tryItem(0, items)), 0)) + "px)",
    }], (elems_1 = toList(delay(() => ofArray(mapIndexed((rowIndex, virtualItem) => {
        const row = item_1(virtualItem.index, table.getRowModel().rows);
        let rowUrl;
        const matchValue_1 = props.Options.OnRowClick;
        let matchResult, url;
        if (matchValue_1 == null) {
            matchResult = 1;
        }
        else if (matchValue_1.tag === 0) {
            matchResult = 1;
        }
        else {
            matchResult = 0;
            url = matchValue_1.fields[0];
        }
        switch (matchResult) {
            case 0: {
                rowUrl = url(row.original);
                break;
            }
            default:
                rowUrl = undefined;
        }
        let isHighlighted;
        const matchValue_2 = props.HighlightedRowPath;
        let matchResult_1, highlightedRowPath, rowUrl_1;
        if (rowUrl != null) {
            if (matchValue_2 != null) {
                matchResult_1 = 0;
                highlightedRowPath = matchValue_2;
                rowUrl_1 = rowUrl;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                isHighlighted = (rowPath(rowUrl_1) === highlightedRowPath);
                break;
            }
            default:
                isHighlighted = false;
        }
        return reactElement_1("div", createObj(toList(delay(() => append(singleton(["key", row.id]), delay(() => append(singleton(["data-index", virtualItem.index]), delay(() => append(isHighlighted ? singleton(["data-highlighted", "true"]) : empty(), delay(() => append(singleton(["ref", (arg) => {
            props.Virtualizer.measureElement(arg);
        }]), delay(() => append(singleton(["className", join(" ", toList(delay(() => append(singleton("group"), delay(() => append(singleton("flex"), delay(() => append(singleton("flex-row"), delay(() => append((props.Options.OnRowClick != null) ? singleton("hover:cursor-pointer") : empty(), delay(() => (isHighlighted ? singleton("bg-[#F2F4FD]") : empty()))))))))))))]), delay(() => {
            let matchValue_4, rowUrl_2;
            return append((matchValue_4 = rowUrl, (matchValue_4 == null) ? (empty()) : ((rowUrl_2 = matchValue_4, singleton(["onClick", (_arg_1) => {
                if (rowPath(window.location.hash) === rowPath(rowUrl_2)) {
                    rememberClickedRow(props.TableKey, rowUrl_2);
                }
            }])))), delay(() => {
                let elems;
                return singleton((elems = toList(delay(() => {
                    let matchValue_5;
                    return append((matchValue_5 = props.Options.RowSelection, (matchValue_5 === "multiRow") ? singleton(createElement(CheckboxTableCell, {
                        BorderStyle: props.Options.BorderStyle,
                        Checked: row.getIsSelected(),
                        OnCheck: (arg_1) => {
                            row.toggleSelected(arg_1);
                        },
                        Row: row,
                        RowIndex: rowIndex,
                    })) : ((matchValue_5 === "singleRow") ? singleton(createElement(CheckboxTableCell, {
                        BorderStyle: props.Options.BorderStyle,
                        Checked: row.getIsSelected(),
                        OnCheck: (arg_1) => {
                            row.toggleSelected(arg_1);
                        },
                        Row: row,
                        RowIndex: rowIndex,
                    })) : (empty()))), delay(() => map((cell) => {
                        const columnDefinition = FSharpMap__get_Item(props.ColumnDefinitionsMap, cell.column.id);
                        const matchValue_6 = columnDefinition.AccessorFunction(row.original);
                        switch (matchValue_6.tag) {
                            case 8:
                                return createElement(DateTableCell, {
                                    BorderStyle: props.Options.BorderStyle,
                                    Cell: cell,
                                    Date: unwrap(matchValue_6.fields[0]),
                                    OnClick: unwrap(props.Options.OnRowClick),
                                    Row: row,
                                    TestId: `row-${rowIndex}-column-${columnDefinition.Id}`,
                                });
                            case 9:
                                return createElement(DateTimeTableCell, {
                                    BorderStyle: props.Options.BorderStyle,
                                    Cell: cell,
                                    Date: unwrap(matchValue_6.fields[0]),
                                    OnClick: unwrap(props.Options.OnRowClick),
                                    Row: row,
                                });
                            case 1:
                                return createElement(LinkTableCell, {
                                    BorderStyle: props.Options.BorderStyle,
                                    Cell: cell,
                                    Href: matchValue_6.fields[1],
                                    OnClick: unwrap(props.Options.OnRowClick),
                                    Row: row,
                                    TestId: `row-${rowIndex}-column-${columnDefinition.Id}`,
                                    Text: matchValue_6.fields[0],
                                });
                            case 2:
                                return createElement(ComponentTableCell, {
                                    BorderStyle: props.Options.BorderStyle,
                                    Cell: cell,
                                    Component: matchValue_6.fields[0],
                                    OnClick: unwrap(props.Options.OnRowClick),
                                    Row: row,
                                    TestId: `row-${rowIndex}-column-${columnDefinition.Id}`,
                                });
                            case 4:
                                return createElement(LabelTableCell, {
                                    BorderStyle: props.Options.BorderStyle,
                                    Cell: cell,
                                    Labels: matchValue_6.fields[0],
                                    OnClick: unwrap(props.Options.OnRowClick),
                                    Row: row,
                                });
                            case 5:
                                return createElement(ComponentTableCell, {
                                    BorderStyle: props.Options.BorderStyle,
                                    Cell: cell,
                                    Component: createElement(InventoryTypeBadge, {
                                        InventoryType: matchValue_6.fields[0],
                                    }),
                                    OnClick: unwrap(props.Options.OnRowClick),
                                    Row: row,
                                    TestId: `row-${rowIndex}-column-${columnDefinition.Id}`,
                                });
                            case 6:
                                return createElement(ImageTableCell, {
                                    BorderStyle: props.Options.BorderStyle,
                                    Cell: cell,
                                    ImageUrls: singleton_1({
                                        ImageUrl: matchValue_6.fields[0],
                                        Position: 1,
                                    }),
                                    Row: row,
                                    TestId: `row-${rowIndex}-column-${columnDefinition.Id}`,
                                });
                            case 7:
                                return createElement(ImageTableCell, {
                                    BorderStyle: props.Options.BorderStyle,
                                    Cell: cell,
                                    ImageUrls: matchValue_6.fields[0],
                                    Row: row,
                                    TestId: `row-${rowIndex}-column-${columnDefinition.Id}`,
                                });
                            case 3:
                                return createElement(ButtonTableCell, {
                                    BorderStyle: props.Options.BorderStyle,
                                    ButtonContent: {
                                        Label: matchValue_6.fields[0],
                                        OnClick: matchValue_6.fields[1],
                                    },
                                    Cell: cell,
                                    Row: row,
                                    TestId: `row-${rowIndex}-column-${columnDefinition.Id}`,
                                });
                            default:
                                return createElement(TextTableCell, {
                                    BorderStyle: props.Options.BorderStyle,
                                    Cell: cell,
                                    OnClick: unwrap(props.Options.OnRowClick),
                                    Row: row,
                                    TestId: `row-${rowIndex}-column-${columnDefinition.Id}`,
                                    Text: matchValue_6.fields[0],
                                });
                        }
                    }, row.getVisibleCells())));
                })), ["children", reactApi.Children.toArray(Array.from(elems))]));
            }));
        }))))))))))))));
    }, items)))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function InfiniteTable(props) {
    let getCoreRowModel, getFilteredRowModel, getSortedRowModel, state_2, enableRowSelection, matchValue, matchValue_1, elems_10;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1(props.TableKey, props.Options.SaveTableConfiguration, props.Options.DefaultColumnFilter, props.Options.DefaultSortColumn, props.Options.WithQueryParameters, props.ColumnDefinitions), update_1, (_arg_1, _arg_1_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const dependencies_2 = [props.ColumnDefinitions];
    reactApi.useEffect(() => {
        dispatch(new TableMsg$1(0, [props.ColumnDefinitions]));
    }, dependencies_2);
    const t = useTranslation()[0];
    const pageFilters = defaultArg(map_1((_arg_3) => _arg_3.ActiveFilters, props.FilterDropDownElements), empty_1());
    const dependencies_4 = [state_1.IsFullscreen];
    reactApi.useEffect(() => {
        if (props.Options.Fullscreen) {
            document.addEventListener("keydown", (e) => {
                if ((e.key === "Escape") && state_1.IsFullscreen) {
                    dispatch(new TableMsg$1(4, []));
                }
            });
        }
    }, dependencies_4);
    const columnDefinition = createColumnDefinition(t, props.ColumnDefinitions, state_1.ColumnFilters);
    const table = useReactTable((getCoreRowModel = getCoreRowModel_1(), (getFilteredRowModel = getFilteredRowModel_1(), (getSortedRowModel = getSortedRowModel_1(), (state_2 = {
        columnFilters: state_1.ColumnFilters,
        columnOrder: state_1.ColumnOrder,
        columnVisibility: getColumnVisibilityObject(props.ColumnDefinitions, state_1.VisibleColumns),
        rowSelection: state_1.SelectedRows,
        sorting: state_1.ColumnSorting,
    }, (enableRowSelection = ((matchValue = props.Options.RowSelection, (matchValue === "singleRow") ? true : (matchValue === "multiRow"))), {
        columnResizeMode: "onChange",
        columns: columnDefinition,
        data: props.TableRows,
        debugTable: false,
        defaultColumn: {
            maxSize: 10000,
            minSize: 75,
            size: 200,
        },
        enableGlobalFilter: true,
        enableMultiRowSelection: (matchValue_1 = props.Options.RowSelection, (matchValue_1 === "singleRow") ? false : (matchValue_1 === "multiRow")),
        enableRowSelection: enableRowSelection,
        enableSortingRemoval: false,
        getCoreRowModel: getCoreRowModel,
        getFilteredRowModel: getFilteredRowModel,
        getSortedRowModel: getSortedRowModel,
        onColumnFiltersChange: (filterUpdater) => {
            dispatch(new TableMsg$1(5, [filterUpdater(state_1.ColumnFilters)]));
        },
        onColumnOrderChange: (arg) => {
            dispatch(new TableMsg$1(9, [arg]));
        },
        onColumnVisibilityChange: (visibilityUpdater) => {
            dispatch(new TableMsg$1(8, [visibilityUpdater(getColumnVisibilityObject(state_1.ColumnDefinitions, state_1.VisibleColumns))]));
        },
        onRowSelectionChange: (rowSelectionUpdater) => {
            dispatch(new TableMsg$1(2, [rowSelectionUpdater(state_1.SelectedRows)]));
        },
        onSortingChange: (sortingUpdater) => {
            dispatch(new TableMsg$1(7, [sortingUpdater(state_1.ColumnSorting)]));
        },
        state: state_2,
    }))))));
    const parentRef = reactApi.useRef(undefined);
    const rowVirtualizer = useVirtualizer({
        count: table.getRowModel().rows.length,
        estimateSize: (_arg_6) => 50,
        getScrollElement: (_arg_5) => parentRef.current,
        overscan: 20,
    });
    const patternInput_2 = reactApi.useState(false);
    const patternInput_3 = reactApi.useState(undefined);
    const patternInput_4 = reactApi.useState(false);
    const lastClickedRowRestored = patternInput_4[0];
    const rows = table.getRowModel().rows;
    const tableConfigurationLoaded = !props.Options.SaveTableConfiguration ? true : (state_1.TableConfiguration.tag === 1);
    const globalSearchApplied = defaultArg(ofNullable(table.getState().globalFilter), "") === state_1.GlobalSearchPattern;
    const dependencies_6 = [lastClickedRowRestored, tableConfigurationLoaded, globalSearchApplied, props.TableRows.length];
    reactApi.useEffect(() => {
        if (((!lastClickedRowRestored && tableConfigurationLoaded) && globalSearchApplied) && (props.TableRows.length > 0)) {
            patternInput_4[1](true);
            const matchValue_3 = props.Options.OnRowClick;
            const matchValue_4 = takeRememberedRowPath(props.TableKey);
            let matchResult, rememberedRowPath, url;
            if (matchValue_3 != null) {
                if (matchValue_3.tag === 1) {
                    if (matchValue_4 != null) {
                        matchResult = 0;
                        rememberedRowPath = matchValue_4;
                        url = matchValue_3.fields[0];
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    iterate((rowIndex) => {
                        const scrollToRow = () => {
                            rowVirtualizer.scrollToIndex(rowIndex, {
                                align: "center",
                            });
                        };
                        patternInput_3[1](rememberedRowPath);
                        scrollToRow();
                        window.requestAnimationFrame((_arg_8) => {
                            scrollToRow();
                            window.requestAnimationFrame((_arg_9) => {
                                iterate((rowElement) => {
                                    rowElement.scrollIntoView({
                                        block: "center",
                                    });
                                }, toArray(bind((scrollElement_2) => ofNullable(scrollElement_2.querySelector(`[data-index='${rowIndex}']`)), parentRef.current)));
                            });
                        });
                    }, toArray(tryFindIndex((row) => (rowPath(url(row.original)) === rememberedRowPath), rows)));
                    break;
                }
                case 1: {
                    break;
                }
            }
        }
    }, dependencies_6);
    return reactElement_1("div", createObj(ofArray([["className", join(" ", toList(delay(() => (state_1.IsFullscreen ? append(singleton("fixed"), delay(() => append(singleton("inset-0"), delay(() => append(singleton("z-[15]"), delay(() => append(singleton("bg-white"), delay(() => append(singleton("flex"), delay(() => append(singleton("flex-col"), delay(() => singleton("pt-6"))))))))))))) : append(singleton("h-[calc(100%-40px)]"), delay(() => append(singleton("flex"), delay(() => singleton("flex-col")))))))))], (elems_10 = toList(delay(() => {
        let elems_4, elems, elems_3;
        return append(((((!isEmpty(props.Controls) ? true : props.Options.ConfigurableColumns) ? true : props.Options.GlobalSearch) ? true : props.Options.CSVDownload) ? true : props.Options.Fullscreen) ? singleton(reactElement_1("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("flex-wrap"), delay(() => append(singleton("shrink-0"), delay(() => append(singleton("gap-y-5"), delay(() => append(singleton("px-6"), delay(() => append(singleton("py-5"), delay(() => append(singleton("top-[0px]"), delay(() => append(singleton("left-1"), delay(() => append(singleton("bg-[#fefefe]"), delay(() => append(singleton("z-10"), delay(() => {
            const matchValue_6 = props.Options.BorderStyle;
            switch (matchValue_6) {
                case "full":
                case "none": {
                    return empty();
                }
                default:
                    return append(singleton("border-b"), delay(() => singleton("border-border")));
            }
        })))))))))))))))))))))))], (elems_4 = [reactElement_1("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "flex-wrap", "gap-x-5", "gap-y-2", "grow", "min-w-0"])], (elems = toList(delay(() => map_2((control) => {
            let OnClick, matchValue_7, onClick, array_3;
            if (control.tag === 1) {
                return createElement(SmallDropdownButton, {
                    Classes: empty_1(),
                    ComponentState: "enabled",
                    DisplayArrow: true,
                    DisplayDivider: false,
                    Elements: map_2((tableControl_1) => {
                        let array_6;
                        let OnClick_1;
                        const matchValue_8 = tableControl_1.OnClick;
                        if (matchValue_8 == null) {
                            OnClick_1 = (() => {
                            });
                        }
                        else {
                            const onClick_1 = matchValue_8;
                            OnClick_1 = (() => {
                                onClick_1(ofArray(map((row_2) => row_2.original, table.getSelectedRowModel().rows)));
                                table.toggleAllRowsSelected(false);
                            });
                        }
                        return {
                            ComponentState: (tableControl_1.OnClick == null) ? "disabled" : (tableControl_1.EnabledOnlyOnSelection ? (((array_6 = table.getSelectedRowModel().rows, array_6.length === 0)) ? "disabled" : "enabled") : "enabled"),
                            DisplayName: tableControl_1.Label,
                            Icon: unwrap(tableControl_1.Icon),
                            OnClick: OnClick_1,
                            TestId: tableControl_1.TestId,
                        };
                    }, control.fields[2]),
                    Label: control.fields[0],
                    TestId: control.fields[1],
                });
            }
            else {
                const tableControl = control.fields[0];
                return createElement(TextButton, (OnClick = ((matchValue_7 = tableControl.OnClick, (matchValue_7 == null) ? (() => {
                }) : ((onClick = matchValue_7, () => {
                    onClick(ofArray(map((row_1) => row_1.original, table.getSelectedRowModel().rows)));
                    table.toggleAllRowsSelected(false);
                })))), {
                    ComponentState: (tableControl.OnClick == null) ? "disabled" : (tableControl.EnabledOnlyOnSelection ? (((array_3 = table.getSelectedRowModel().rows, array_3.length === 0)) ? "disabled" : "enabled") : "enabled"),
                    Icon: unwrap(tableControl.Icon),
                    Label: tableControl.Label,
                    OnClick: OnClick,
                    TestId: tableControl.TestId,
                    Variant: "default",
                }));
            }
        }, props.Controls))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement_1("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "items-center", "gap-x-5", "gap-y-2", "shrink-0", "ml-auto"])], (elems_3 = toList(delay(() => append(singleton(createElement(TableElementsCounter, {
            NumberOfElements: table.getRowModel().rows.length,
            TotalNumberOfElements: unwrap(hasActiveFilters(state_1, pageFilters) ? max(countRowsMatchingColumnFilters(t, props.ColumnDefinitions, defaultArg(map_1(toArray_1, state_1.DefaultColumnFilters), []), props.TableRows), table.getRowModel().rows.length) : undefined),
        })), delay(() => append(props.Options.GlobalSearch ? singleton(createElement(IconInput, {
            ComponentState: "enabled",
            LeftIcon: Magnifying_Glass(),
            OnChange: (globalSearchValue) => {
                if (props.Options.WithQueryParameters) {
                    setQueryParams("global-search", globalSearchValue);
                }
                dispatch(new TableMsg$1(1, [globalSearchValue]));
            },
            TestId: "global-search-input",
            Value: state_1.GlobalSearchPattern,
        })) : empty(), delay(() => append(props.Options.ConfigurableColumns ? singleton(createElement(ColumnSelect, {
            ButtonLabel: t("table.columns"),
            ComponentState: "enabled",
            Items: ofArray(map((column) => {
                let matchValue_9;
                const Id = column.columnDef.id;
                return {
                    Checked: column.getIsVisible(),
                    Group: (matchValue_9 = FSharpMap__TryFind(state_1.ColumnDefinitionMap, column.id), (matchValue_9 == null) ? "" : matchValue_9.Group),
                    Id: Id,
                    Name: column.columnDef.header,
                    OnCheck: (_arg_12) => {
                        column.toggleVisibility(!column.getIsVisible());
                    },
                };
            }, table.getAllLeafColumns())),
            TestId: "infinite-table-columm-select",
        })) : empty(), delay(() => append((props.Options.CustomTableFilters ? true : (props.FilterDropDownElements != null)) ? singleton(createElement(TableFilterDropDown, {
            ColumnDefinitionMap: state_1.ColumnDefinitionMap,
            ColumnFilters: state_1.ColumnFilters,
            CustomTableFilters: props.Options.CustomTableFilters,
            Dispatch: dispatch,
            FilterDropDown: unwrap(props.FilterDropDownElements),
            SavedFilters: state_1.SavedFilters,
        })) : empty(), delay(() => append(singleton(createElement(TableSettings, {
            CSVDownloadActivated: props.Options.CSVDownload,
            CSVDownloadRunning: state_1.CSVDownloadRunning,
            ColumnDefinitionMap: state_1.ColumnDefinitionMap,
            Dispatch: dispatch,
            ResetConfigurationEnabled: props.Options.SaveTableConfiguration,
            ResetFilterEnabled: props.ColumnDefinitions.some((columnDefinition_1) => (columnDefinition_1.Filter !== "none")),
            Table: table,
        })), delay(() => {
            let elems_2, elems_1;
            return props.Options.Fullscreen ? singleton(reactElement_1("button", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-center", "cursor-pointer"])], ["onClick", (_arg_13) => {
                dispatch(new TableMsg$1(4, []));
            }], (elems_2 = [reactElement_1("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5"])], (elems_1 = toList(delay(() => (state_1.IsFullscreen ? singleton(Compress()) : singleton(Expand())))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty();
        })))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : empty(), delay(() => append(singleton(createElement(ActiveFilterBar, {
            Dispatch: dispatch,
            PageFilters: pageFilters,
            State: state_1,
        })), delay(() => {
            let elems_9;
            return singleton(reactElement_1("div", createObj(ofArray([["ref", parentRef], ["data-test-id", "infinite-table-scroll-container"], ["onScroll", (scrollEvent) => {
                const scrollElement = scrollEvent.currentTarget;
                patternInput_2[1](scrollElement.scrollTop > scrollElement.clientHeight);
            }], ["className", join(" ", ["flex-1", "min-h-0", "overflow-auto", "bg-white"])], (elems_9 = toList(delay(() => append(singleton(createElement(InfiniteBaseTable, {
                ColumnDefinitions: props.ColumnDefinitions,
                ColumnDefinitionsMap: state_1.ColumnDefinitionMap,
                GlobalSearch: state_1.GlobalSearchPattern,
                HighlightedRowPath: unwrap(patternInput_3[0]),
                IsHeaderDraggable: props.Options.SaveTableConfiguration,
                Options: {
                    BorderStyle: props.Options.BorderStyle,
                    ConfigurableColumns: props.Options.ConfigurableColumns,
                    OnRowClick: unwrap(props.Options.OnRowClick),
                    RowSelection: props.Options.RowSelection,
                    StickyHeader: true,
                    WithQueryParameters: props.Options.WithQueryParameters,
                },
                Table: table,
                TableKey: props.TableKey,
                TableRows: props.TableRows,
                Virtualizer: rowVirtualizer,
            })), delay(() => {
                let elems_8, elems_7, elems_6, elems_5;
                return patternInput_2[0] ? singleton(reactElement_1("div", createObj(ofArray([["className", join(" ", ["sticky", "bottom-0", "left-0", "z-[2]", "h-0", "w-full"])], (elems_8 = [reactElement_1("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "pr-6", "-translate-y-14"])], (elems_7 = [createElement(IconButton, {
                    ComponentState: "enabled",
                    Icon: reactElement_1("div", createObj(ofArray([["title", t("table.scroll_to_top")], ["className", join(" ", ["flex", "h-10", "w-10", "items-center", "justify-center", "rounded-full", "border", "border-border", "bg-white", "shadow-md", "hover:bg-[#F2F4FD]"])], (elems_6 = [reactElement_1("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems_5 = [Arrow_Up_3()], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))),
                    OnClick: () => {
                        iterate((scrollElement_1) => {
                            scrollElement_1.scrollTo({
                                behavior: "smooth",
                                top: 0,
                            });
                        }, toArray(parentRef.current));
                    },
                    TestId: "infinite-table-scroll-to-top",
                })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))) : empty();
            })))), ["children", reactApi.Children.toArray(Array.from(elems_9))])]))));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_10))])])));
}

